
import React from 'react';
import { Loader2 } from 'lucide-react';
import { useIntersectionObserver } from '@/hooks/ui/use-intersection-observer';

interface ResearchLoadMoreButtonProps {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
}

export const ResearchLoadMoreButton: React.FC<ResearchLoadMoreButtonProps> = ({
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
}) => {
  // Use intersection observer to trigger loading when this element comes into view
  const [targetRef] = useIntersectionObserver({
    onIntersect: onLoadMore,
    enabled: hasNextPage && !isFetchingNextPage,
    threshold: 0.1,
    rootMargin: '100px', // Start loading 100px before the element is visible
  });

  if (!hasNextPage && !isFetchingNextPage) {
    return null;
  }

  return (
    <div ref={targetRef} className="flex justify-center pt-4">
      {isFetchingNextPage && (
        <div className="flex items-center justify-center p-4">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          <span className="ml-2 text-sm text-muted-foreground">Loading more...</span>
        </div>
      )}
    </div>
  );
};

export default ResearchLoadMoreButton;
